
(function(){
  // Settings (match your custom liquid block field IDs/names)
  var REG_INPUT_SELECTOR = '#reg-input';
  var CHOICE_NAME = 'properties[Plate Choice]'; // radios

  function findProductForm(){
    // Prefer closest to the price/add block, fallback to first add-to-cart form
    var forms = document.querySelectorAll('form[action^="/cart/add"]');
    return forms.length ? forms[0] : null;
  }

  function sanitize(v){
    return (v||'').toUpperCase().replace(/[^A-Z0-9 ]/g,'');
  }

  function ensureHidden(form, name, value){
    // Remove previous injected input
    var prev = form.querySelector('input[type="hidden"][name="'+name+'"]');
    if (prev) prev.remove();
    var el = document.createElement('input');
    el.type = 'hidden'; el.name = name; el.value = value;
    form.appendChild(el);
  }

  function getReg(){
    var el = document.querySelector(REG_INPUT_SELECTOR);
    return el ? sanitize(el.value) : '';
  }

  function getChoice(){
    var sel = document.querySelector('input[name="'+CHOICE_NAME+'"]:checked');
    return sel ? sel.value : '';
  }

  function hook(){
    var form = findProductForm();
    if (!form || form.__ppHooked) return;
    form.__ppHooked = true;

    // Keep hidden fields updated for dynamic checkout buttons
    function mirror(){
      var reg = getReg();
      var choice = getChoice();
      if (reg)   ensureHidden(form, 'properties[Registration]', reg);
      if (choice) ensureHidden(form, CHOICE_NAME, choice);
      // make each add-to-cart unique so separate designs never merge
      ensureHidden(form, 'properties[_uniq]', String(Date.now()));
    }

    ['submit','click','change','input'].forEach(function(ev){
      form.addEventListener(ev, mirror, true);
      document.addEventListener(ev, mirror, true);
    });
    mirror();
  }

  document.addEventListener('DOMContentLoaded', hook);
  document.addEventListener('shopify:section:load', hook);
  document.addEventListener('shopify:section:select', hook);
})();
